<template>
  <div class="creditSummary">
    <div class="creditSummary__header">
      <div class="creditSummary__headerInfo">
        <div class="creditSummary__icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <g clip-path="url(#clip0_creditSummary)">
              <path d="M15.4796 3.82864L13.4723 1.11664C13.2254 0.771526 12.8999 0.490216 12.5226 0.296021C12.1454 0.101826 11.7273 0.00033863 11.303 -2.93427e-05H4.69629C4.27405 -0.000425674 3.85774 0.0994527 3.48164 0.291386C3.10554 0.483319 2.78039 0.761821 2.53296 1.10397L0.489625 3.8353C0.156934 4.30443 -0.0148786 4.86869 -9.6703e-05 5.44362C0.0146851 6.01855 0.215266 6.57323 0.571625 7.02464L6.43296 15.2433C6.61975 15.4798 6.85782 15.6708 7.12922 15.8019C7.40061 15.933 7.69824 16.0007 7.99963 16C8.30619 15.9994 8.60852 15.9284 8.88336 15.7926C9.15821 15.6568 9.39823 15.4598 9.58496 15.2166L15.3996 7.0893C15.7719 6.63129 15.9818 6.0627 15.9963 5.47263C16.0107 4.88256 15.829 4.30436 15.4796 3.82864ZM12.3943 1.90064L14.4063 4.6193C14.417 4.63397 14.4196 4.6513 14.4303 4.66664H11.169L10.217 1.3333H11.303C11.5169 1.33397 11.7276 1.38581 11.9175 1.48451C12.1073 1.5832 12.2708 1.72588 12.3943 1.90064ZM7.99963 12.7453L6.19963 5.99997H9.79963L7.99963 12.7453ZM6.21696 4.66664L7.16896 1.3333H8.83029L9.78229 4.66664H6.21696ZM3.61096 1.8913C3.73466 1.7189 3.89759 1.57838 4.0863 1.48136C4.27502 1.38434 4.4841 1.33359 4.69629 1.3333H5.78229L4.83029 4.66664H1.54496C1.55429 4.65197 1.55696 4.63397 1.56762 4.61997L3.61096 1.8913ZM1.63162 6.21664C1.58349 6.14865 1.54218 6.07607 1.50829 5.99997H4.82096L6.81696 13.4866L1.63162 6.21664ZM9.18029 13.4933L11.1803 5.99997H14.5043C14.4613 6.09948 14.407 6.19367 14.3423 6.28064L9.18029 13.4933Z" fill="#1A61EA"></path>
              <path d="M15.4796 3.82864L13.4723 1.11664C13.2254 0.771526 12.8999 0.490216 12.5226 0.296021C12.1454 0.101826 11.7273 0.00033863 11.303 -2.93427e-05H4.69629C4.27405 -0.000425674 3.85774 0.0994527 3.48164 0.291386C3.10554 0.483319 2.78039 0.761821 2.53296 1.10397L0.489625 3.8353C0.156934 4.30443 -0.0148786 4.86869 -9.6703e-05 5.44362C0.0146851 6.01855 0.215266 6.57323 0.571625 7.02464L6.43296 15.2433C6.61975 15.4798 6.85782 15.6708 7.12922 15.8019C7.40061 15.933 7.69824 16.0007 7.99963 16C8.30619 15.9994 8.60852 15.9284 8.88336 15.7926C9.15821 15.6568 9.39823 15.4598 9.58496 15.2166L15.3996 7.0893C15.7719 6.63129 15.9818 6.0627 15.9963 5.47263C16.0107 4.88256 15.829 4.30436 15.4796 3.82864ZM12.3943 1.90064L14.4063 4.6193C14.417 4.63397 14.4196 4.6513 14.4303 4.66664H11.169L10.217 1.3333H11.303C11.5169 1.33397 11.7276 1.38581 11.9175 1.48451C12.1073 1.5832 12.2708 1.72588 12.3943 1.90064ZM7.99963 12.7453L6.19963 5.99997H9.79963L7.99963 12.7453ZM6.21696 4.66664L7.16896 1.3333H8.83029L9.78229 4.66664H6.21696ZM3.61096 1.8913C3.73466 1.7189 3.89759 1.57838 4.0863 1.48136C4.27502 1.38434 4.4841 1.33359 4.69629 1.3333H5.78229L4.83029 4.66664H1.54496C1.55429 4.65197 1.55696 4.63397 1.56762 4.61997L3.61096 1.8913ZM1.63162 6.21664C1.58349 6.14865 1.54218 6.07607 1.50829 5.99997H4.82096L6.81696 13.4866L1.63162 6.21664ZM9.18029 13.4933L11.1803 5.99997H14.5043C14.4613 6.09948 14.407 6.19367 14.3423 6.28064L9.18029 13.4933Z" fill="#9BA5C2"></path>
            </g>
            <defs>
              <clipPath id="clip0_creditSummary">
                <rect width="16" height="16" fill="white"></rect>
              </clipPath>
            </defs>
          </svg>
        </div>
        <div class="creditSummary__titleArea">
          <span class="creditSummary__title">{{ t('credit-banner') }}</span>
          <div class="infoGuide">
            <button type="button" class="btnTxt creditDescButton">
              {{ t('credit-certify-invitation-button') }}
            </button>
            <ul>
              <li>{{ t('pricing-faq-question-4-answer-1') }}</li>
              <li>{{ t('pricing-faq-question-4-answer-2') }}</li>
              <li>
                <NuxtLink to="/settings/org?tab=CreditManagement" target="_blank">
                  <span class="icon"></span>{{ t('credit-detail-button') }}
                </NuxtLink>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <span class="creditSummary__badge">{{ userStore.userV2.credit }}</span>
    </div>
    <span class="creditSummary__divider"></span>
    <div class="creditSummary__usage">
      <div class="creditSummary__calc">
        <span v-html="candidateCountContent"></span>
        <span class="creditSummary__arrow">→</span>
        <span v-html="creditUsedContent"></span>
      </div>
      <p class="creditSummary__perCandidate">{{ t('skillCertify-invite-candidates-credit-count-per-candidate', { count: creditPerCandidate }) }}</p>
    </div>
    <span class="creditSummary__divider"></span>
    <div class="creditSummary__remaining" :class="{ insufficient: isInsufficientCredit }">
      <template v-if="!isInsufficientCredit">
        <span>{{ t('skillCertify-invite-candidates-estimated-remaining') }}</span>
        <span class="creditSummary__badge">{{ remainingCredit }}</span>
      </template>
      <template v-else>
        <div class="creditSummary__remainingText">
          <span>{{ t('skillCertify-invite-candidates-insufficient-credits') }}</span>
          <NuxtLink to="/settings/org?tab=CreditManagement" target="_blank" class="creditSummary__manageLink">
            <svg xmlns="http://www.w3.org/2000/svg" width="3" height="6" viewBox="0 0 3 6" fill="none">
              <path d="M-5.00516e-07 5.99609L-1.35899e-05 -1.31135e-07L3 2.99805L-5.00516e-07 5.99609Z" fill="#D26F6F"/>
            </svg>
            {{ t('credit-certify-creation-limit-button') }}
          </NuxtLink>
        </div>
        <span class="creditSummary__badge red">{{ remainingCredit }}</span>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { useUserStore } from "~/store/user/userStore";

const { t } = useI18n();
const userStore = useUserStore();

const props = defineProps({
  candidateCount: { type: Number, default: 0 },
  creditPerCandidate: { type: Number, default: 0 },
});

const requiredCredit = computed(() => props.candidateCount * props.creditPerCandidate);
const remainingCredit = computed(() => userStore.userV2.credit - requiredCredit.value);
const isInsufficientCredit = computed(() => remainingCredit.value < 0);

const highlightCount = (translated: string, count: number): string =>
  translated.replace(String(count), `<span class="creditSummary__count">${count}</span>`);

const candidateCountContent = computed(() =>
  highlightCount(t('skillCertify-invite-candidates-candidate-count', { count: props.candidateCount }), props.candidateCount)
);
const creditUsedContent = computed(() =>
  highlightCount(t('skillCertify-invite-candidates-credit-count', { count: requiredCredit.value }), requiredCredit.value)
);
</script>

<style>
.creditDescButton {
  font-weight: 500;
  color: #4785FF !important;
}
</style>
